import { CLEAR_STRUCT_TREE } from "../../../enums/Request/leader.requests.types";

export const clearStructureTreeAction = () => {
    return {
        type: CLEAR_STRUCT_TREE,
    };
};